module.exports = __webpack_public_path__ + "static/media/bart-720p.77e75a87.png";